import { inject } from 'vue'
import { ProviderKeys } from '@/app/providers/provider-keys.ts'

export function useAppAxios() {
  const appAxios = inject(ProviderKeys.AppAxios)

  if (!appAxios) {
    throw new Error('Could not find provider AppAxios')
  }

  return appAxios
}
